import { render, staticRenderFns } from "./updata-diy-topic.vue?vue&type=template&id=b175e13e"
import script from "./updata-diy-topic.vue?vue&type=script&lang=js"
export * from "./updata-diy-topic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b175e13e')) {
      api.createRecord('b175e13e', component.options)
    } else {
      api.reload('b175e13e', component.options)
    }
    module.hot.accept("./updata-diy-topic.vue?vue&type=template&id=b175e13e", function () {
      api.rerender('b175e13e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/topic-list/updata-diy-topic.vue"
export default component.exports